var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-waiting-sample-recollect',{ref:"table",staticClass:"pt-waiting-sample-recollect__withData",attrs:{"pageSize":_vm.pageSize,"exportLoading":_vm.exportLoading},on:{"exportResampleOrder":_vm.exportResampleOrder}})}
var staticRenderFns = []

export { render, staticRenderFns }